import { Component, OnInit } from '@angular/core';
import { LinkCardContent } from '../parts/card/card.component';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
})
export class IndexComponent implements OnInit {
  linkContents: LinkCardContent[] = [
    {
      href: '/pharmacy/login',
      title: '薬局ログイン',
    },
    {
      href: '/pharmacist/login',
      title: '薬剤師ログイン',
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
